import { Button } from '@archipro-design/aria';
import { MoreFill } from '@archipro-design/icons';
import { useDesignBoardPageState } from '~/modules/design-board/component/context';
import type {
    DrawerReducerState,
    MobileBottomMenuData,
} from '~/modules/design-board/type/main-context-types';

interface ToggleBottomMenuButtonProps {
    className?: string;
    bottomMenuData: MobileBottomMenuData;
    currentPinData?: DrawerReducerState['currentPinData'];
    currentBoardData?: DrawerReducerState['currentBoardData'];
}

export const ToggleBottomMenuButton = ({
    className = 'more-button',
    bottomMenuData,
    currentPinData,
    currentBoardData,
}: ToggleBottomMenuButtonProps) => {
    const { dispatch } = useDesignBoardPageState();

    const onClick = (e: React.SyntheticEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (currentPinData || currentBoardData) {
            dispatch({
                type: 'SetCurrentBoardPin',
                currentPinData,
                currentBoardData,
            });
        }
        // prevent the previous dispatch data not updated
        setTimeout(() => {
            dispatch({
                type: 'OpenMobileBottomMenuDrawer',
                bottomMenuData,
            });
        }, 200);
    };

    return (
        <Button
            color="grey"
            iconBefore={<MoreFill />}
            size={24}
            variables={{
                buttonPadding: 0,
                iconPadding: 0,
                buttonSize24IconXMargin: '0',
                buttonRadius: '50%',
            }}
            className={className}
            onClick={onClick}
        ></Button>
    );
};
